export const CLIENT_ACCOUNT_PATH = '/accounts/me'
export const CLIENT_TEAM_MEMBERS_PATH = '/team_members'
export const CLIENT_INVESTMENT_PLANS_PATH = '/investment_plans'
export const PORTFOLIO_ACCOUNT_PATH = '/portfolios/:portfolioId'
export const PORTFOLIO_DETAILS_PATH = '/v1/client/portfolios/:portfolioId'
export const PORTFOLIO_CLASS_ALLOCS_PATH = '/v1/client/portfolios/:portfolioId/class_allocations'
export const PORTFOLIO_ACCOUNTS_PATH = '/v1/client/portfolios/:portfolioId/financial_accounts'
export const PORTFOLIO_HOLDINGS_PATH = '/v1/client/portfolios/:portfolioId/holdings'
export const DOCUMENTS_PATH = '/v1/client/documents'
export const FILE_PATH = '/v1/client/files/:fileId'
export const NOTIFICATIONS_PATH = '/notifications'
export const UPDATE_USER_DISMISSED_PATH = '/notifications/:notificationId'



// WEBPACK FOOTER //
// ./src/utils/Client/apiPaths.js